import { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { BOX_SHADOW_THEME, INPUT_COLOR_BORDER } from "../../utils/colors";
import { BORDER_RADIUS } from "../../utils/constants";

const TooltipOptimization = ({
  isOpen = false,
  titleTooltip = "",
  actionTooltip = "",
  children,
}) => {
  const [isOpenInternal, setIsOpenInternal] = useState(true);

  const onClose = () => {
    setIsOpenInternal(false);
  };

  return (
    <Tooltip
      open={isOpen && isOpenInternal}
      title={
        <Box sx={{ position: "relative" }}>
          <IconButton
            size="small"
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              padding: 0.5,
              zIndex: 1,
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
          <Typography
            variant="body1"
            sx={{
              pt: 2.5,
              pb: 1,
              pl: 1,
              fontWeight: 600,
            }}
          >
            {titleTooltip}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              p: 1,
            }}
          >
            {actionTooltip}
          </Typography>
        </Box>
      }
      arrow
      placement="bottom"
      componentsProps={{
        popper: {
          sx: {
            zIndex: 1000,
          },
        },
        tooltip: {
          sx: {
            p: 0.5,
            backgroundColor: "fields.background",
            border: `1px solid ${INPUT_COLOR_BORDER}`,
            boxShadow: BOX_SHADOW_THEME,
            borderRadius: BORDER_RADIUS,
            color: "#000",
            mt: "8px !important",
            ".MuiTooltip-arrow": {
              color: "#000",
            },
            width: 260,
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default TooltipOptimization;
